<template>
  <div class="flashbuy" :style="{ background: banner[0] && banner[0].bgcolor }">
    <navbar :title="pageTitie" left-text show-home></navbar>
    <div class="banner">
      <p>{{ pageTime }}</p>
      <img v-lazy="banner[0] && banner[0].img" />
    </div>
    <ul class="cards" v-show="cardList.length">
      <van-list
        :finished="finished"
        @load="onLoad"
        finished-text="没有更多了"
        v-model="loading"
      >
        <li
          @click="goodsTap(item)"
          v-for="(item, index) in cardList"
          :key="index"
        >
          <aside>
            <img v-lazy="item.pic_url" />
          </aside>
          <article>
            <h3>{{ item.name }}</h3>
            <p class="buy-price">¥{{ item.activity.discount }}</p>
            <span class="market-price">¥{{ item.market_price }}</span>
            <div class="btn">
              <div class="over" v-if="item.activity.num - 0 <= 0">已抢购</div>
              <div class="go" v-else>
                <p>去抢购</p>
                <div class="process-bg">
                  <div class="process">
                    <i
                      :style="{
                        width:
                          (
                            (item.activity.total_num - item.activity.num - 0) /
                            item.activity.total_num
                          ).toFixed(3) *
                            100 +
                          '%',
                      }"
                    ></i>
                  </div>
                  <span
                    >{{
                      (
                        (item.activity.total_num - item.activity.num - 0) /
                        item.activity.total_num
                      ).toFixed(3) * 100
                    }}%</span
                  >
                </div>
              </div>
            </div>
          </article>
        </li>
      </van-list>
    </ul>
  </div>
</template>
<script>
import Navbar from '../../components/NavBar'
import api from '../../utils/api'
import { List } from 'vant'
let flag = false
let loadOn = false
export default {
  components: {
    VanList: List, Navbar
  },
  data () {
    return {
      loading: false,
      finished: false,
      pageNum: 1,
      noData: false,
      banner: [],
      cardList: [],
      column: 0,
      pageTime: '',
      pageTitie: ''
    }
  },
  created () {
    this.getPageJson()
  },
  watch: {
    column () {
      this.getCardsList()
    }
  },
  methods: {
    async goodsTap (item) {
      if (item.activity && !item.activity.num - 0) {
        return false
      }
      if (loadOn) {
        return false
      }
      loadOn = true
      const goodsid = item.item_id
      const skuid = item.sku_id
      const platform = item.platform
      const type = item.item_type
      await api.routeJump({ goodsid, skuid, platform, type })
      loadOn = false
    },
    onLoad () {
      if (flag) {
        return
      }
      flag = true
      setTimeout(() => {
        this.getCardsList(++this.pageNum).then(() => {
          setTimeout(() => {
            this.loading = false
            flag = false
          }, 500)
        })
      }, 500)
    },
    async getPageJson () {
      const data = await api.getJsonVersion('snap')
      const title = data['snap-title']
      this.pageTitie = title && title.data.length && title.data[0] && title.data[0].title
      document.title = this.pageTitie
      this.banner = data['snap-1-1'] && data['snap-1-1'].data
      this.pageTime = this.banner && this.banner[0].title
      const p1 = data['snap-lm']
      this.column = p1 && p1.data.length && p1.data[0] && p1.data[0].column
    },
    async getCardsList () {
      const myData = await this.$axios.get(`/api/goods/channelItems/${this.column}/${this.pageNum}`)
      if (myData.status === 200) {
        const { code, data, msg } = myData.data
        if (code === 0) {
          if (this.pageNum === 1) {
            this.noData = true
          }
          this.cardList = [...this.cardList, ...data]
        } else if (code === 9006) {
          this.finished = true
          if (this.pageNum === 1) {
            this.noData = true
          }
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>
<style lang='less' scoped>
.flashbuy {
  min-height: 100vh;
  .banner {
    position: relative;
    p {
      position: absolute;
      bottom: 0.62rem;
      left: -0.3rem;
      transform: translate(50%, 0);
      text-align: center;
      font-size: @fz22;
      color: #dc1e36;
      padding: 0 0.15rem;
      line-height: 0.55rem;
      height: 0.55rem;
      background: linear-gradient(180deg, #fdfcdc, #f9f7b6);
      border-radius: 0.28rem;
    }
  }
  .cards {
    margin: 0.24rem;
    li {
      border-radius: 0.08rem;
      background: #fff;
      padding: 0.2rem;
      display: flex;
      margin-bottom: 0.2rem;
      aside {
        width: 1.9rem;
        height: 1.9rem;
      }
      article {
        width: 4.4rem;
        margin-left: 0.2rem;
        height: 1.9rem;
        position: relative;
        h3 {
          font-size: @fz26;
          color: #3f3f3f;
          line-height: 0.4rem;
          .ellipsis2;
        }
        .buy-price {
          position: absolute;
          left: 0;
          bottom: 0.4rem;
          font-size: @fz22;
          color: #ff4141;
        }
        .market-price {
          position: absolute;
          left: 0;
          bottom: 0;
          font-size: @fz22;
          color: #9b9b9b;
          text-decoration: line-through;
        }
        .btn {
          position: absolute;
          bottom: 0;
          right: 0;
          width: 1.68rem;
          height: 0.74rem;
          .over {
            line-height: 0.74rem;
            text-align: center;
            font-size: @fz24;
            color: #646464;
            background: #ededed;
            height: 0.74rem;
            border-radius: 0.08rem;
          }
          .go {
            height: 0.74rem;
            border-radius: 0.08rem;
            background: linear-gradient(180deg, #ff5600, #ff3000);
            p {
              padding-top: 0.1rem;
              font-size: @fz24;
              color: #fff;
              text-align: center;
            }
            .process-bg {
              margin: 0 0.1rem;
              height: 0.3rem;
              .flex-between;
              .process {
                width: 1rem;
                height: 0.06rem;
                background: #ffaa91;
                border-radius: 0.03rem;
                overflow: hidden;
                i {
                  display: block;
                  background: #fff;
                  height: 0.06rem;
                }
              }
              span {
                color: #ffaa91;
                font-size: 0.2rem;
              }
            }
          }
        }
      }
    }
  }
}
</style>
